import { render, staticRenderFns } from "./ProductToggle.vue?vue&type=template&id=c1775626&"
import script from "./ProductToggle.vue?vue&type=script&lang=js&"
export * from "./ProductToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports